// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","price":"price-2A8Pr","total":"total-14q4p","totalTitle":"totalTitle-bRzqy","money":"money-11KkH","row":"row-1D5Jh"};